import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryBricksUnderMinimun extends AnnualSummaryError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks is less than the minimum to buy', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default AnnualSummaryBricksUnderMinimun;
